var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewInAr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 6C2.55 6 3 5.55 3 5V4C3 3.45 3.45 3 4 3H5C5.55 3 6 2.55 6 2C6 1.45 5.55 1 5 1H4C2.34 1 1 2.34 1 4V5C1 5.55 1.45 6 2 6Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 21H4C3.45 21 3 20.55 3 20V19C3 18.45 2.55 18 2 18C1.45 18 1 18.45 1 19V20C1 21.66 2.34 23 4 23H5C5.55 23 6 22.55 6 22C6 21.45 5.55 21 5 21Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 1H19C18.45 1 18 1.45 18 2C18 2.55 18.45 3 19 3H20C20.55 3 21 3.45 21 4V5C21 5.55 21.45 6 22 6C22.55 6 23 5.55 23 5V4C23 2.34 21.66 1 20 1Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22 18C21.45 18 21 18.45 21 19V20C21 20.55 20.55 21 20 21H19C18.45 21 18 21.45 18 22C18 22.55 18.45 23 19 23H20C21.66 23 23 21.66 23 20V19C23 18.45 22.55 18 22 18Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19 14.87V9.13C19 8.41 18.62 7.75 18 7.4L13 4.52C12.69 4.34 12.35 4.25 12 4.25C11.65 4.25 11.31 4.34 11 4.52L6 7.39C5.38 7.75 5 8.41 5 9.13V14.87C5 15.59 5.38 16.25 6 16.6L11 19.48C11.31 19.66 11.65 19.75 12 19.75C12.35 19.75 12.69 19.66 13 19.48L18 16.6C18.62 16.25 19 15.59 19 14.87ZM11 17.17L7 14.87V10.24L11 12.57V17.17ZM12 10.84L8.04 8.53L12 6.25L15.96 8.53L12 10.84ZM17 14.87L13 17.17V12.57L17 10.24V14.87Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewInAr);
export default __webpack_public_path__ + "static/media/ViewInAr.9862abf4045e59a89102fcb62ebd7ec9.svg";
export { ForwardRef as ReactComponent };